// en.js 
export default {
  loginRegisterB:{
    support:"技术支持：",
    tel:"联系电话：",
    mail:"联系邮箱：",
    address:"联系地址",
    icp:"ICP备案号：",
  }
}